import { all, fork } from "redux-saga/effects";
import profileSaga from "./profile/saga";
import stripeSaga from "./stripe/saga";
import processingPaymentsSaga from "./processingPayment/saga";
import interviewSaga from "./interview/saga";

const rootSaga = function*() {
  yield all([
    fork(profileSaga),
    fork(stripeSaga),
    fork(processingPaymentsSaga),
    fork(interviewSaga),
  ])
}

export default rootSaga;